import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'

export const makeTitleCase = (str) => {
  return startCase(toLower(str));
};
